module.exports = __webpack_public_path__ + "arkanoid.png?48bb3135b9887eb7517c5577a7ef3b57";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/arkanoid.png
// module id = 230
// module chunks = 0